<template>
    <div class="clearfix">
        <div v-if="items.length === 0 && !noResults">
            Loading...
        </div>
        <div v-if="noResults">
            <br />
            <div class="alert alert-warning alert-dismissible fade show" role="alert">
                There are no trades to show, click <strong>Import Trades</strong> to import your trades
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </div>
        <div v-else>

            <div v-for="(market) in unique(items, 'marketId')" :key="market.marketId">
                <h5>{{ market.marketName }}</h5> 
                <table class="table table-dark table-sm table-striped table-hover table-bordered small" style="table-layout: fixed;">
                    <caption>all amounts are in {{ market.holdingCurrencyCode }}</caption>
                    <thead>
                        <tr>
                            <th scope="col" style="width: 30%;">Security</th>
                            <th scope="col" class="text-center" style="width: 5%;"> <input type="checkbox" id="checkbox" v-model="isArchived" v-on:click="filterHoldings()" /> </th>
                            <th scope="col" class="d-none d-sm-table-cell" style="width: 10%;">Curr. Price</th>
                            <th scope="col" style="width: 10%;">Units</th>
                            <th scope="col" class="d-none d-sm-table-cell" style="width: 10%;">Value</th>
                            <th scope="col" style="width: 10%;">PnL</th>
                            <th scope="col" style="width: 10%;">Divs</th>
                            <th scope="col" style="width: 15%;">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item) in filteredMarkets(market.marketId)" :key="item.security">
                            <td><a class="text-white" :href="'/Trades/Individual?security=' + item.security + '&marketId=' + item.marketId">{{ item.security }}&nbsp;<span class="d-none d-sm-table-cell">-&nbsp;{{ item.securityName}}</span></a></td>
                            <td class="text-center"><input type="checkbox" id="checkbox" v-model="item.isArchived" v-on:click="editHolding(item)"/></td>
                            <td class="text-right d-none d-sm-table-cell">{{item.price | currency('$')}}</td>
                            <td class="text-right"><span v-if="item.units !== 0">{{item.units | number('0,0') }}</span></td>
                            <td class="text-right d-none d-sm-table-cell"><span v-if="item.value !== 0">{{item.value | currency('$', 0)}}</span></td>
                            <td :class="['text-right', applyColor(item.profit)]">{{item.profit | currency('$', 0)}}</td>
                            <td class="text-right"><span v-if="item.dividends !== 0">{{item.dividends | currency('$', 0)}}</span></td>
                            <td class="text-right">{{item.total | currency('$', 0)}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
   
</template>

<script>
    import axios from 'axios';    

    export default {
        props: {
            portfolioguid: String,
            securityprop: String
        },
        data: function () {
            return {               
                securities : [], 
                items: [],    
                unfiltered : [], 
                portfolioGuid: this.portfolioguid,
                security: this.securityprop,
                noResults: false,
                isArchived: false
            }
        },
        async mounted() {
            this.getTrades();            
        },
        methods: {   
            applyColor(field) {          
                if (field >= 0) return 'text-success';
                if (field < 0) return 'text-danger';               

            },
            getData(obj) {
                console.log(obj);                
            },
            getSecurities: function (security) {
                return this.items.find(a => a.security === security)
            },
            filteredMarkets(marketId) {
                return this.items.filter(item => item.marketId === marketId);
            },
            filteredItems(security) {
                return this.items.filter(item => item.security === security);
            },
            filteredDividends(security) {
                return this.dividends.filter(item => item.code === security);
            },
            editHolding(holding) {
                console.log(holding);
            },
            filterHoldings() {
                console.log(this.isArchived);

                
                this.items = this.unfiltered.filter(item => item.isArchived === !this.isArchived);
            },
            async getTrades() {

                const { data } = await axios.get('/api/trades/GetPnLByPortfolio', {
                    params: {
                        portfolioGuid: this.portfolioGuid,
                        security: this.security,
                        resultsInPortfolioCurrency : false
                    }
                });

                this.items = data;
                this.unfiltered = data;
                this.noResults = data.length === 0;
            }
        }
    }
</script>
